interface Props {
  label: string
  /** Pixel anchor in the canvas-container coordinate space. */
  x: number
  y: number
}

/**
 * What hovering a node says about it: its name, and nothing we cannot show
 * from the graph itself.
 *
 * It used to have a second, richer variant that drew an alert — entity,
 * severity colour and a description like "Flow at 2,550 bpm, IOW max 2,600".
 * Every word of that came from the MOCK_ALERTS literal, and the alert was
 * attached to whichever leaf node came next in array order, so a fabricated
 * process-safety reading appeared over a real, unrelated equipment tag. There
 * is no alerts API to replace it with, so the card shows what the graph knows.
 */
const NodeHoverCard = ({ label, x, y }: Props) => {
  return (
    <div
      className="absolute z-20 pointer-events-none -translate-y-1/2"
      style={{ left: x + 8, top: y }}
    >
      <div className="rounded-md border border-border bg-background shadow-md px-3 py-2 max-w-[260px]">
        <p className="text-sm text-foreground break-words">{label}</p>
      </div>
    </div>
  )
}

export default NodeHoverCard
